import type { ComponentLike } from '@glint/template';

import NotificationsEditFormBaseComponent, {
	type ChunkInterface,
	type MainChunkInterface,
} from 'webapp/components/notifications/edit/form/base';
import MainComponent, {
	type ValidationErrorsType,
} from 'webapp/components/notifications/edit/form/scorecard/main';
import TitleComponent from 'webapp/components/notifications/edit/form/scorecard/title';

import type { Scorecard } from 'webapp/models-custom';

export default class NotificationsEditFormScorecardComponent extends NotificationsEditFormBaseComponent {
	get model() {
		return this.args.model as Scorecard;
	}

	get errors() {
		return this.args.errors as ValidationErrorsType;
	}

	get titleComponent() {
		return TitleComponent as ComponentLike<ChunkInterface>;
	}

	get mainComponent() {
		return MainComponent as ComponentLike<MainChunkInterface>;
	}
}
